










import { Vue, Component, Prop } from "vue-property-decorator";
import { VIPIp } from "@/loader";

@Component
export default class IpBadge extends Vue {
	@Prop({ type: VIPIp, required: true })
	public ip!: VIPIp;

	@Prop({ type: String, default: "secondary" })
	public variant!: string;

	@Prop({ type: Boolean, default: false })
	public canRemove!: boolean;

	@Prop({ type: Boolean, default: false })
	public showText!: boolean;

	public get tooltip(): string {
		return `<b>${this.ip.name}</b><br/><br/>${this.ip.description?.replace(/\r?\n/, "<br/>") || ""}`;
	}
}
